import React from 'react';
import { Masks } from 'shared/helpers';
import propTypes from 'prop-types';

import { Master, First, Row, Break } from './Table.module.scss';

export default function Table({ data, totalArea, productionUnit = 'kg' }) {
  const { number, currency } = Masks;
  const UNIT = productionUnit || 'kg';
  return (
    <div className={Master}>
      <header>
        <div>Item</div>
        <div>Recomendação SQM VITAS Brasil</div>
        <div>Recomendação Convencional</div>
      </header>
      <main>
        <div className={Row}>
          <div className={First}>Custo Nutricional Final</div>
          <div id='custo_final_sqm'>
            {currency(data.finalCosts[0], { suffix: ' /ha' })}
          </div>
          <div id='custo_final_conv'>
            {currency(data.finalCosts[1], { suffix: ' /ha' })}
          </div>
        </div>
        <div className={Row}>
          <div className={First}>Produtividade em {UNIT}</div>
          <div id='produtividade_sqm'>
            {number(data.productivity[0], { suffix: `${UNIT}` })}
          </div>
          <div id='produtividade_conv'>
            {number(data.productivity[1], { suffix: `${UNIT}` })}
          </div>
        </div>
        <div className={Row}>
          <div className={First}>
            Preço médio de produto obtido por qualidade
          </div>
          <div id='preco_medio_sqm'>
            {currency(data.avgPrices[0], { ed: 2, suffix: ` /${UNIT}` })}
          </div>
          <div id='preco_medio_conv'>
            {currency(data.avgPrices[1], { ed: 2, suffix: ` /${UNIT}` })}
          </div>
        </div>
        <div className={Row}>
          <div className={First}>Receita Bruta</div>
          <div id='receita_bruta_sqm'>
            {currency(data.fullIncome[0], { suffix: ' /ha' })}
          </div>
          <div id='receita_bruta_conv'>
            {currency(data.fullIncome[1], { suffix: ' /ha' })}
          </div>
        </div>
        <div className={Row}>
          <div className={First}>
            {'"Receita Líquida"'} (Receita bruta menos somente o custo nutricional)
          </div>
          <div id='receita_liq_sqm'>
            {currency(data.finalIncome[0], { suffix: ' /ha' })}
          </div>
          <div id='receita_liq_conv'>
            {currency(data.finalIncome[1], { suffix: ' /ha' })}
          </div>
        </div>
        <div className={Break} />
        <div className={Row}>
          <div className={First}>Diferença de Receita Líquida R$/ha</div>
          <div id='difer_receita_liq'>
            {currency(data.finalIncome[0] - data.finalIncome[1], {
              suffix: ' /ha',
            })}
          </div>
        </div>
        <div className={Row}>
          <div className={First}>
            Diferença de Receita Líquida na área total
          </div>
          <div id='difer_receita_liq_total'>
            {`${currency(
              (data.finalIncome[0] - data.finalIncome[1]) * Number(totalArea),
            )}`}
          </div>
        </div>
        <div className={Row}>
          <div className={First}>Diferença de Receita Líquida /ha em %</div>
          <div id='difer_receita_liq_percent'>
            {number((data.finalIncome[0] / data.finalIncome[1]) * 100 - 100, {
              suffix: '%',
            })}
          </div>
        </div>
      </main>
    </div>
  );
}

Table.propTypes = {
  data: propTypes.any.isRequired,
  totalArea: propTypes.number.isRequired,
  productionUnit: propTypes.string.isRequired,
};
